import React from 'react';
import { View } from 'react-native';

import { useFinancialSummary } from '@/hooks/use-financial-summary';
import { useOperationalMetrics } from '@/hooks/use-provider';
import { useRecentCharges } from '@/hooks/use-recent-charges';
import { CHARGE_STATUS } from '@/types/charge-status';
import { formatCurrency } from '@/utils/format-currency';
import { formatDate } from '@/utils/format-date';
import { SummaryEmpty, SummaryRow, SummarySkeleton, SummaryStat } from '../home-summary-dialog';

/** Prévia de "Recebido": saldo do mês e últimos pagamentos confirmados. */
export function RevenueSummary() {
  const { data: metrics } = useOperationalMetrics();
  const { data: financial } = useFinancialSummary();
  const { data: charges, isLoading } = useRecentCharges(20);

  const paid = (charges ?? []).filter((charge) => charge.status === CHARGE_STATUS.PAID).slice(0, 4);

  return (
    <View className="gap-3">
      <View className="flex-row gap-2">
        <SummaryStat
          label="Recebido no mês"
          value={formatCurrency(metrics?.monthlyRevenue ?? 0)}
          tone="positive"
        />
        <SummaryStat
          label="Disponível"
          value={formatCurrency(financial?.balance.available ?? 0)}
        />
      </View>

      {isLoading ? (
        <SummarySkeleton rows={3} />
      ) : paid.length ? (
        <View className="gap-2">
          {paid.map((charge) => (
            <SummaryRow
              key={charge.id}
              icon="checkmark-circle-outline"
              title={charge.clientName ?? charge.enrollment?.client?.user?.username ?? 'Cliente'}
              description={`Pago em ${formatDate(charge.paidAt ?? charge.updatedAt)}`}
              value={formatCurrency(charge.amount)}
              valueTone="positive"
            />
          ))}
        </View>
      ) : (
        <SummaryEmpty message="Nenhum pagamento confirmado ainda." />
      )}
    </View>
  );
}
